import { createContext, useState, Dispatch, SetStateAction } from "react";

type IContext = {
    locale: string,
    setLocale: Dispatch<SetStateAction<string>>
}


export const LangContext = createContext({} as IContext);